// extracted by mini-css-extract-plugin
module.exports = {"image":"go-to-app-page_image__1sEiq","mobilePreview":"go-to-app-page_mobilePreview__10V8m","phoneFrame":"go-to-app-page_phoneFrame__2AzAw"};